import { useSelector } from "react-redux";
import Accountprice from "../../../utils/Accountprice"

const Summary = ({Count}) => {
    const { bgColor, textColor } = useSelector((state) => state.theam);
  return (
     <div className="py-2 px-2"  style={{ background: "#ffff", borderRadius: 6 }} >                             
                                
                  <h4
                          style={{
                            padding: "0px 14px",
                            fontWeight: 700,
                          }}
                          className="titlesizes"
    
                        >
                          Payment Summary
                        </h4>
    
                    <div
                      className="firstrow px-3 d-flex justify-content-between"
                      style={{ padding: "5px 0px" }}
                    >
                      <span
                        className="family"
                        style={{ fontWeight: 600, fontSize: "12px" }}
                      >
                        Taxable Amount ({Count.totalqty} Item(s))
           
                      </span>
                      <span
                        className="family"
                        style={{
                          fontWeight: 500,
                          color: `#${bgColor}`,
                          fontSize: "12px",
                        }}
                      >
                   
    {Accountprice((Count.taxable_total).toFixed(0))}
    
                      </span>
                    </div>
                    <div
                      className="firstrow px-3 d-flex justify-content-between"
                      style={{ padding: "5px 0px" }}
                    >
                      <span
                        className="family"
                        style={{ fontWeight: 600, fontSize: "12px" }}
                      >
                        GST Amount
                      </span>
                      <span
                        className="family"
                        style={{
                          fontWeight: 500,
                          color: `#${bgColor}`,
                          fontSize: "12px",
                        }}
                      >
                        +
                        {Accountprice(Count.gst_total)}
                      </span>
                    </div>
                    <div
                      className="firstrow px-3 d-flex justify-content-between"
                      style={{ padding: "5px 0px" }}
                    >
                      <span
                        className="family"
                        style={{ fontWeight: 600, fontSize: "12px" }}
                      >
                        Shipping Charges
                      </span>
                      <span
                        className="family"
                        style={{
                          fontWeight: 500,
                          color: `#${bgColor}`,
                          fontSize: "12px",
                        }}
                      >
                      +
                      {Accountprice(Count.shippingCharges)}
                      </span>
                    </div>
                    {Count.is_Credit_Applied || Count.creditAmount ? <div
                      className="firstrow px-3 d-flex justify-content-between"
                      style={{ padding: "5px 0px" }}
                    >
                      <span
                        className="family"
                        style={{ fontWeight: 600, fontSize: "12px" }}
                      >
                        Credit Utilize
                      </span>
                      <span
                        className="family"
                        style={{
                          fontWeight: 500,
                          color: `#${bgColor}`,
                          fontSize: "12px",
                        }}
                      >
                      {Count.creditAmount ? Count.creditAmount : `-${Accountprice(Math.abs(Count.AllowCredit))}`}
                      
                      </span>
                    </div> : ''}
                  
  
              
    
    
    
                    <div className="firstrow px-3 pt-1 d-flex justify-content-between">
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: "12px",
                          paddingLeft: "0px",
                        }}
                      >
                            Amount Payable
                       
                      </span>
                      <span
                        style={{
                          fontWeight: 500,
                          color: `#${bgColor}`,
                          fontSize: "12px",
                        }}
                      >  
                    {Accountprice(((Count.taxable_total + Count.gst_total + Count.shippingCharges) - (Count.is_Credit_Applied ? Count.AllowCredit : 0)).toFixed(0))}
                      </span>
                    </div>
               
                  </div>
  )
}

export default Summary